<template>
  <main>
    <v-content>
      <v-container fluid grid-list-md id="home" class="listar">
        <v-layout row wrap>
          <v-flex xs10>
            <v-text-field
              prepend-icon="search"
              class="general-search"
              box
              height="55"
              label="Procurar Corretor"
              single-line
              v-model="searchFilter.generalSearch"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 class="criar-menu-container">
            <router-link
              tag="button"
              :to="{ path: '/corretores/novo' }"
              button
              class="btn-primary jns-button jns-adicionar-novo-button"
            >
              Adicionar &nbsp;
              <v-icon>add_circle_outline</v-icon>
            </router-link>
          </v-flex>
          <v-flex xs12>
            <v-data-table
              v-if="corretores"
              :headers="headers"
              :items="filteredCorretores"
              :pagination.sync="pagination"
              :rows-per-page-items="[10, 20]"
              :loading="loading"
              :rows-per-page-text="'Linhas por página'"
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.cpf_cnpj }}</td>
                <td class="text-xs-left">{{ props.item.nome }}</td>
                <td class="text-xs-left">{{ props.item.emailSusep }}</td>
                <td class="text-xs-left">{{ props.item.telefone }}</td>
                <td class="text-xs-left">{{ props.item.estado }}</td>
              </template>

              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
                >Sua pesquisa por "{{ search }}" não encontrou
                resultados.</v-alert
              >
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";
export default {
  name: "CorretorListar",
  mixins: [ViewMixin],
  data: () => ({
    searchFilter: {
      generalSearch: "",
    },
    menu: null,
    generalSearch: "",
    corretores: false,
    search: "",
    loading: false,
    pagination: {},
    headers: [
      {
        text: "CNPJ / CPF",
        align: "left",
        sortable: false,
      },
      {
        text: "Nome",
        align: "left",
        sortable: false,
      },
      {
        text: "Email Susep",
        align: "left",
        sortable: false,
      },
      {
        text: "Telefone",
        align: "left",
        sortable: false,
      },
      {
        text: "Estado",
        align: "left",
        sortable: false,
      },
    ],
  }),

  computed: {
    filteredCorretores() {
      var t = this;
      let items = t.corretores;
      let filters = t.searchFilter;

      if (items.length == 0) return [];

      if (!filters.generalSearch) {
        return items;
      }

      let tempItems = items;

      if (filters.generalSearch) {
        tempItems = tempItems.filter(
          (item) =>
            item.emailSusep
              .toLowerCase()
              .indexOf(filters.generalSearch.toLowerCase()) !== -1 ||
            item.cpf_cnpj
              .toLowerCase()
              .indexOf(filters.generalSearch.toLowerCase()) !== -1 ||
            item.nome
              .toLowerCase()
              .indexOf(filters.generalSearch.toLowerCase()) !== -1
        );
      }
      return tempItems;
    },
  },
  methods: {
    grabColorByType(type) {
      let color = "";
      switch (type) {
        case "COTACAO":
          color = "#FF9700";
          break;

        case "PROPOSTA":
          color = "#7ED321";
          break;

        case "PROPOSTA_ENVIADAS":
          color = "#4589F3";
          break;
      }
      return color;
    },

    darkenEverythingExcept(selector) {
      let t = this;
      let el = document.querySelector(selector);
      el.className += " shadow-everything-except";
      let shadowText = el.querySelector(".shadow-text");
      shadowText.style.display = "block";

      setTimeout(() => {
        el.classList.remove("shadow-everything-except");
        shadowText.style.display = "none";
      }, 5000);
    },
  },

  mounted() {
    let t = this;

    t.$store.dispatch("TEST_TOKEN").then((response) => {});
    t.corretores = t.$settings.mocks.corretores;
    t.$store.commit("SET_LOADING_INDICATOR_FLAG", false);
    t.alert = t.handleAlertText();
  },
};
</script>


<style lang="scss" scoped>
#jns {
  .input-group {
    padding: 0;
  }
  .general-search label {
    top: 0 !important;
  }
  .jns-adicionar-novo-button {
    i {
      color: white;
    }
    &:hover {
      i {
        color: #4589f3;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Corretores/Listar.vue